import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import { PRIZE_INFO_TYPES} from '../../core/constants/actionTypes';


export const prizeInfoReducer = createAsyncReducer(PRIZE_INFO_TYPES.GET_PRIZE_INFO.PREFIX, {count: 0, prizeInfos: []});
export const currentDistributionsReducer = createAsyncReducer(PRIZE_INFO_TYPES.GET_CURRENT_DISTRIBUTIONS.PREFIX, {});



